// Shared vocabulary for the Annexure III / IV scoring sheet. Kept apart
// from the card so the sheet, the score strip and the member matrix can
// all speak it without importing each other.

export interface CriterionBand {
  v: number;
  hint?: string;
}

export interface Criterion {
  key: string;
  label: string;
  max: number;
  bands: readonly CriterionBand[];
}

export interface MemberScore {
  member_name: string;
  // Directory user the name was picked from — required on submit. Rows
  // recorded before it was required carry only `member_name`; null while a
  // row in the editor has no user picked yet.
  member_user_id?: string | null;
  scores: Record<string, number>;
}

/**
 * Which band a raw score falls into, so the input and the guidance tiles
 * stay in sync in both directions. Picking a tile already sets the input;
 * this powers the reverse — typing a score selects the tile it lands on.
 * Bands are ascending discrete scores (e.g. 10/20/30/40) and a score
 * lights up the band it has *reached*: the largest band value ≤ the score
 * (floor bucket). An exact score still matches its own band; a score below
 * the lowest band — or a blank field — matches nothing. Order-independent
 * so a future band reordering can't silently break it.
 */
export function matchingBand(
  value: number | "",
  bands: readonly CriterionBand[],
): number | null {
  if (typeof value !== "number") return null;
  let match: number | null = null;
  for (const b of bands) {
    if (value >= b.v && (match === null || b.v > match)) match = b.v;
  }
  return match;
}
